<template>
  <div class="editor-popup">
    <div class="editor-popup__content">
      <div class="editor-popup__close" @click="close" />

      <div class="editor-popup__content-type">
        <h3 class="editor-popup__title">Add media</h3>
      </div>
      <div class="change-type">
        <div class="change-type__button" @click="handleChangeType('audio')">
          <span
            class="change-type__text"
            :style="{ color: type === 'audio' ? '#00BFFF' : '#bfbfbf' }"
          >Audio</span>
          <div class="change-type__icon">
            <img :src="require('../../../assets/editor/audio.svg')" alt="audio icon" />
          </div>
        </div>
        <div class="change-type__button" @click="handleChangeType('pdf')">
          <span
            class="change-type__text"
            :style="{ color: type === 'pdf' ? '#00BFFF' : '#bfbfbf' }"
          >File</span>
          <div class="change-type__icon">
            <img :src="require('../../../assets/editor/pdf.svg')" alt="pdf icon" />
          </div>
        </div>
        <div class="change-type__button" @click="handleChangeType('video')">
          <span
            class="change-type__text"
            :style="{ color: type === 'video' ? '#00BFFF' : '#bfbfbf' }"
          >Video</span>
          <div class="change-type__icon">
            <img :src="require('../../../assets/editor/video.svg')" alt="video icon" />
          </div>
        </div>
        <div class="change-type__button" @click="handleChangeType('link')">
          <span
            class="change-type__text"
            :style="{ color: type === 'link' ? '#00BFFF' : '#bfbfbf' }"
          >Audio</span>
          <div class="change-type__icon">
            <img :src="require('../../../assets/editor/link.svg')" alt="link icon" />
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Select File</label>
        <div class="input input--file">
        <div class="file-label"></div>
        <input
          type="text"
          class="input input--outline"
          id="file"
          placeholder=""
          v-model="file"
        />
        </div>
      </div>

      <div class="field">
        <label class="label">Title</label>
        <input
          type="text"
          class="input input--outline"
          id="title"
          placeholder="Necessary"
          v-model="title"
        />
      </div>
      <div class="field">
        <label class="label">Author</label>
        <input
          type="text"
          class="input input--outline"
          id="author"
          placeholder="_"
          v-model="author"
        />
      </div>
      <div class="field">
        <label class="label">Description</label>
        <input
          type="text"
          class="input input--outline"
          id="description"
          placeholder="_"
          v-model="description"
        />
      </div>
      <div class="field">
        <button class="button button--info button--fluid" @click="upload">save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import api from "../../../api";

export default {
  data() {
    return {
      type: "audio",
      title: "",
      author: "",
      description: "",
      file: ""
    };
  },
  computed: {
    ...mapState([
      "selectedProject",
    ]),
  },
  methods: {
    ...mapMutations(["closePopup", "setSelectedProject"]),
    handleChangeType(type) {
      this.type = type;
    },
    // onFileChange() {
    //   this.file = this.$refs.myFiles.files;
    //   console.log(this.file);
    // },
    upload() {
      const project = Object.assign({}, this.selectedProject)
      const media = {
        name: this.title,
        path: this.file,
        type: this.type,
        description: this.description,
        author: this.author
      }

      project.media.push(media);

      api.projects.updateProject(project._id, project).then(response => {
        this.setSelectedProject(project)
      }).catch(function (error) {
        console.log(error);
      })

      this.closePopup("addMedia");
    },
    close() {
      this.closePopup("addMedia");
    }
  }
};
</script>

<style lang="scss" scoped>
.change-type {
  display: flex;
  margin-bottom: 40px;

  &__text {
    margin-bottom: 5px;
    font-size: 22px;
    color: #b8b8b8;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
    width: 93px;
    height: 75px;
  }

  &__button {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    margin-right: 15px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
